import * as TypeGraphQL from "type-graphql";
export var ModelVersionArtifactScalarFieldEnum;
(function (ModelVersionArtifactScalarFieldEnum) {
    ModelVersionArtifactScalarFieldEnum["id"] = "id";
    ModelVersionArtifactScalarFieldEnum["modelVersionId"] = "modelVersionId";
    ModelVersionArtifactScalarFieldEnum["modelArtifactId"] = "modelArtifactId";
    ModelVersionArtifactScalarFieldEnum["createdAt"] = "createdAt";
})(ModelVersionArtifactScalarFieldEnum || (ModelVersionArtifactScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(ModelVersionArtifactScalarFieldEnum, {
    name: "ModelVersionArtifactScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=ModelVersionArtifactScalarFieldEnum.js.map